import * as fuzzy from "fuzzy";

/***
 * Utility functions for working with the search bar in the
 * navigation component
 *
 */
export const search = (dataset, searchOn, input, filter) => {
	if (input === null || input === undefined) return [];
	input = input.trim();

	// Check
	if (input.length <= 1) {
		return [];
	}

	const searchedArray = [];
	const searchArray = dataset.reduce((array, datapoint) => {
		if (filter) {
			datapoint = filter(datapoint);
			if (datapoint === undefined) {
				return array;
			}
		}
		const item = searchOn
			.map((key) => (datapoint[key] || "").toString().trim())
			.join(" ");
		array.push(item);
		searchedArray.push(datapoint);
		return array;
	}, []);

	// Matching first and last name
	const results = fuzzy.filter(input, searchArray, {
		pre: "<b>",
		post: "</b>",
	});

	// Matching the email portion
	// let emailSearchArray = searchArray;
	// let emailResults = fuzzy.filter(input, emailSearchArray, {
	//   pre: '<b>', post: '</b>'
	// });

	return results.map((result) => {
		const _results = result.string.split(" ");
		const _nameBrokendown = _results.slice(0, _results.length - 2).join(" ");
		const _emailBrokendown = _results[_results.length - 2];

		return {
			...searchedArray[result.index],
			_searchResult: _nameBrokendown,
			_emailSearchResult: _emailBrokendown,
		};
	});
};

export const uniqueArray = (array, accessor) => {
	return Array.from(new Set(array));
};

export const flatten = (array) => {
	if (typeof array.flat === "function") {
		return array.flat(Infinity);
	}
	if (!Array.isArray(array)) {
		// if not an array, return as is
		return array;
	}

	const flat = [];
	array.forEach(function callback(value) {
		if (Array.isArray(value)) {
			value.forEach(callback); // traverse through sub-arrays recursively
		} else {
			flat.push(value);
		}
	});
	return flat;
};

export const uniquePush = (array, item) => {
	if (!array.includes(item)) {
		array.push(item);
	}
	return array;
};

export const toggleItem = (array, item) => {
	if (array.includes(item)) {
		array = array.filter((arrayItem) => arrayItem !== item);
	} else {
		array.push(item);
	}

	return array;
};
